
import validCard from '../modules/card-validator-israel';

const isRequired = value => (value ? undefined : 'missing-field')
const isCreditCard = value => validCard.number(value).isValid ? undefined : "invalid-Credit-Card"
const number = value =>
  value && isNaN(Number(value)) ? 'must-be-a-number' : undefined

export { isRequired, isCreditCard, number }



// WEBPACK FOOTER //
// ./src/lib/forms/Validations.js